import { useTranslate } from "ra-core";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { useIsAdmin } from "../sales/useIsAdmin";
import { TasksListContent } from "./TasksListContent";

export const MobileTasksList = () => {
  const translate = useTranslate();
  const { isAdmin, isPending } = useIsAdmin();

  // See TasksList: rendering before admin status resolves flashes the wrong
  // scope and costs an extra query.
  if (isPending) return null;

  return (
    <>
      <MobileHeader>
        <h1 className="text-xl font-semibold">
          {translate("resources.tasks.name", { smart_count: 2 })}
        </h1>
      </MobileHeader>
      <MobileContent>
        <TasksListContent
          scope={isAdmin ? "all" : "mine"}
          groupByOwner={isAdmin}
        />
      </MobileContent>
    </>
  );
};
